<div class="fuse-mail-modal dialog-content-wrapper">
  <div class="unsave-header">
    {{'user.send_invitation' | translate}}
  </div>
  <div mat-dialog-content class="m-0">
    <p class="unsave-data-text">
      <mat-icon>info</mat-icon>
      <span>{{'user.send_invitation_msg' | translate}}</span>
    </p>
  </div>

  <div mat-dialog-actions class="m-0 p-10" fxLayout="row" fxLayoutAlign="space-between center" class="unsave-footer">
    <button mat-button (click)="dialogRef.close('yes')">{{'yes' | translate}}</button>
    <button mat-button (click)="dialogRef.close('no')">{{'no' | translate}}</button>
  </div>
</div>
